import { useLayoutEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { HOST } from "./seoHead";
import { legacyTarget } from "./legacy";

const setMeta = (name, content) => {
  const el = document.head.querySelector(`meta[name="${name}"]`) || document.head.appendChild(document.createElement("meta"));
  el.setAttribute("name", name);
  el.setAttribute("content", content);
};

export function LegacyRedirect({ to, location }) {
  const { pathname } = useLocation();
  const target = to || legacyTarget(pathname.replace(/^\/store(?=\/)/, ""));
  const [ready, setReady] = useState(false);
  useLayoutEffect(() => {
    setMeta("prerender-status-code", "301");
    setMeta("prerender-header", `Location: ${HOST}${location || target}`);
    setReady(true);
  }, [target, location]);
  return ready ? <Navigate to={target} replace /> : null;
}
